import { render } from "./UploadDialog.vue?vue&type=template&id=4d45d507&scoped=true"
import script from "./UploadDialog.vue?vue&type=script&lang=js"
export * from "./UploadDialog.vue?vue&type=script&lang=js"

import "./UploadDialog.vue?vue&type=style&index=0&id=4d45d507&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d45d507"]])

export default __exports__